import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks } from './navLinks';
import PillLink from '@/components/base/PillLink';

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 bg-background-100/95 backdrop-blur border-b border-background-200">
      <div className="mx-auto max-w-[1280px] px-5 md:px-12 lg:px-16 h-16 md:h-[72px] flex items-center justify-between">
        <Link to="/" className="text-[19px] font-medium tracking-tight cursor-pointer whitespace-nowrap">
          Daywell <span className="em-serif text-[22px]">Living</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8" aria-label="Main">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) => `dw-nav-link text-[14px] whitespace-nowrap transition-colors duration-200 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-500 ${isActive ? 'text-foreground-950' : 'text-foreground-600 hover:text-foreground-950'}`}
            >
              {l.label}
            </NavLink>
          ))}
          <PillLink to="/visit#enquiry" size="sm">Book a Visit</PillLink>
        </nav>
        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </div>
      <div className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-200 ease-out bg-background-100 ${open ? 'max-h-96 opacity-100 border-t border-background-200' : 'max-h-0 opacity-0 pointer-events-none'}`} aria-hidden={!open}>
        <nav className="px-5 py-5 flex flex-col gap-1" aria-label="Mobile">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) => `py-3 text-[17px] border-b border-background-200 cursor-pointer transition-colors duration-200 ${isActive ? 'text-foreground-950' : 'text-foreground-600'}`}
            >
              {l.label}
            </NavLink>
          ))}
          <div className="pt-4">
            <PillLink to="/visit#enquiry">Book a Visit</PillLink>
          </div>
        </nav>
      </div>
    </header>
  );
}